import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import pla_haz_lev from "../img/sswpIcons/PlantAndEquipment/pla_haz_lev.png";
import pla_360_bea from "../img/sswpIcons/PlantAndEquipment/pla_360_war_bea.png";
import pla_acc_poi_ste from "../img/sswpIcons/PlantAndEquipment/pla_acc_poi_ste.png";
import pla_atv_tra_ppe from "../img/sswpIcons/PlantAndEquipment/pla_atv_tra_ppe.png";
import pla_bur_hot_air_lan from "../img/sswpIcons/PlantAndEquipment/pla_bur_hot_lan.png";
import pla_com_pla_sec from "../img/sswpIcons/PlantAndEquipment/pla_com_pla_sec.png";
import pla_exa_inp from "../img/sswpIcons/PlantAndEquipment/pla_exa_ins.png";
import pla_exc_che_val from "../img/sswpIcons/PlantAndEquipment/pla_exc_che_val.png";
import pla_exc_zon from "../img/sswpIcons/PlantAndEquipment/pla_exc_zon.png";
import pla_fir_gro from "../img/sswpIcons/PlantAndEquipment/pla_fir_gro.png";
import pla_gas_bot_sto from "../img/sswpIcons/PlantAndEquipment/pla_gas_bot_sto.png";
import pla_gas_cyl_tra from "../img/sswpIcons/PlantAndEquipment/pla_gas_cyl_bio.png";
import pla_pto_gua from "../img/sswpIcons/PlantAndEquipment/pla_gua_pto.png";
import pla_ker_mac from "../img/sswpIcons/PlantAndEquipment/pla_ker_mac_pin.png";
import pla_loc_att from "../img/sswpIcons/PlantAndEquipment/pla_loc_att.png";
import pla_mir from "../img/sswpIcons/PlantAndEquipment/pla_mir.png";
import pla_no_tip from "../img/sswpIcons/PlantAndEquipment/pla_no_tip.png";
import pla_rev_cam from "../img/sswpIcons/PlantAndEquipment/pla_rev_cam.png";
import pla_rev_dev from "../img/sswpIcons/PlantAndEquipment/pla_rev_war_dev.png";
import pla_roa_pla_pin_fal from "../img/sswpIcons/PlantAndEquipment/pla_roa_pla_pin.png";
import pla_roc_bre_cab_pro from "../img/sswpIcons/PlantAndEquipment/pla_roc_bre_cab.png";
import pla_rol_ove_pro from "../img/sswpIcons/PlantAndEquipment/pla_rol_over_pro.png";
import pla_saf_dri from "../img/sswpIcons/PlantAndEquipment/pla_saf_dri.png";
import pla_saf_par from "../img/sswpIcons/PlantAndEquipment/pla_saf_par.png";
import pla_sea_bel from "../img/sswpIcons/PlantAndEquipment/pla_sea_bel.png";
import pla_sel_sui from "../img/sswpIcons/PlantAndEquipment/pla_sel_sui.png";
import pla_sit_spe_con from "../img/sswpIcons/PlantAndEquipment/pla_sit_spe_con.png";
import pla_sli_sig from "../img/sswpIcons/PlantAndEquipment/pla_sli_sig.png";
import pla_str from "../img/sswpIcons/PlantAndEquipment/pla_str.png";
import pla_veh_pla_con from "../img/sswpIcons/PlantAndEquipment/pla_veh_pla_con.png";
import pla_veh_rec from "../img/sswpIcons/PlantAndEquipment/pla_vel_rec.png";
import pla_veh_tur from "../img/sswpIcons/PlantAndEquipment/pla_vel_tur.png";
import pla_vib_con from "../img/sswpIcons/PlantAndEquipment/pla_vib_con_ser.png";
import pla_wor_on_foo from "../img/sswpIcons/PlantAndEquipment/pla_wor_on_foo.png";

import pla_dus_muc_cle_rem from "../img/sswpIcons/PlantAndEquipment/pla_dus_muc_cle.png";
import pla_2_way_rad from "../img/sswpIcons/PlantAndEquipment/pla_2_way_rad.png";
import pla_blo_gra from "../img/sswpIcons/PlantAndEquipment/pla_blo_gra.png";
import pla_cem_mix from "../img/sswpIcons/PlantAndEquipment/pla_cem_mix.png";
import pla_con_pum from "../img/sswpIcons/PlantAndEquipment/pla_con_pum.png";
import pla_con_ski from "../img/sswpIcons/PlantAndEquipment/pla_con_ski.png";
import pla_cra_cor from "../img/sswpIcons/PlantAndEquipment/pla_cra_cor.png";
import pla_cra from "../img/sswpIcons/PlantAndEquipment/pla_cra.png";
import pla_cru_pla from "../img/sswpIcons/PlantAndEquipment/pla_cru_pla.png";
import pla_dea_man_han from "../img/sswpIcons/PlantAndEquipment/pla_dea_man_han.png";
import pla_del_tra from "../img/sswpIcons/PlantAndEquipment/pla_del_tra.png";
import pla_for_cla_ext from "../img/sswpIcons/PlantAndEquipment/pla_for_cla_ext.png";
import pla_gla_suc from "../img/sswpIcons/PlantAndEquipment/pla_gla_suc.png";
import pla_sti from "../img/sswpIcons/PlantAndEquipment/pla_sti.png";
import pla_gra_cut from "../img/sswpIcons/PlantAndEquipment/pla_gra_cut.png";
import pla_sit_spe_met from "../img/sswpIcons/PlantAndEquipment/pla_sit_spe_met.png";
import pla_loa_sta from "../img/sswpIcons/PlantAndEquipment/pla_loa_sta.png";
import pla_pum_con from "../img/sswpIcons/PlantAndEquipment/pla_pum_con.png";
import pla_no_pas from "../img/sswpIcons/PlantAndEquipment/pla_no_pas.png";
import pla_saf_wor_loa from "../img/sswpIcons/PlantAndEquipment/pla_saf_wor_loa.png";
import pla_sla_lif_gea from "../img/sswpIcons/PlantAndEquipment/pla_sla_lif_gea.png";
import pla_ove_hea_lin from "../img/sswpIcons/PlantAndEquipment/pla_oh_lin.png";
import pla_veh_mov from "../img/sswpIcons/PlantAndEquipment/pla_vel_mov.png";
import pla_tel from "../img/sswpIcons/PlantAndEquipment/pla_tel.png";
import pla_gra_lor from "../img/sswpIcons/PlantAndEquipment/pla_gra_lor.png";
import pla_saf_cli from "../img/sswpIcons/PlantAndEquipment/pla_saf_cli.png";
import pla_rem_con from "../img/sswpIcons/PlantAndEquipment/pla_rem_con.png";
import pla_wat_bow from "../img/sswpIcons/PlantAndEquipment/pla_wat_bow.png";
import pla_ski_bin from "../img/sswpIcons/PlantAndEquipment/pla_ski_bin.png";
import pla_pla_lif from "../img/sswpIcons/PlantAndEquipment/pla_pla_lif.png";
import pla_che_lif_gea from "../img/sswpIcons/PlantAndEquipment/pla_che_lif_gea.png";
import pla_man_cra from "../img/sswpIcons/PlantAndEquipment/pla_man_cra.png";

const json = {
    icon: pla_haz_lev,
    name: "Plant & Equipment",
    text: "",
    icons: {
        pla_360_war_bea: {
            name: "360 Warning Beacons",
            icon: pla_360_bea,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Safety Device Schedule
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Machine</th>
                                    <th>360 Warning beacons</th>
                                    <th>Reversing alarm</th>
                                    <th>Convex mirrors</th>
                                    <th>Movement alarm</th>
                                    <th>Convex mirror / CCTV</th>
                                </tr>
                                <tr>
                                    <td>Backhoe Loader</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>360 Excavator</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (no cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (with cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Off Road Dumper (> 7 Tonnes)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Loading Shovel</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Roller without cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Roller with cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Telescopic Handler</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Bulldozer</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Scraper</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Graders</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        pla_mir: {
            name: "Mirrors",
            icon: pla_mir,
            text: (
                <ul>
                    <ListItem text="Ensure mirrors are positioned to give you easy and clear visibility over the required field of view" />
                    <Li>
                        <Typography variant="title">
                            Safety Device Schedule
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Machine</th>
                                    <th>360 Warning beacons</th>
                                    <th>Reversing alarm</th>
                                    <th>Convex mirrors</th>
                                    <th>Movement alarm</th>
                                    <th>Convex mirror / CCTV</th>
                                </tr>
                                <tr>
                                    <td>Backhoe Loader</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>360 Excavator</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (no cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (with cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Off Road Dumper (> 7 Tonnes)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Loading Shovel</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Roller without cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Roller with cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Telescopic Handler</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Bulldozer</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Scraper</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Graders</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        pla_rev_war_dev: {
            name: "Reversing Warning Device",
            icon: pla_rev_dev,
            text: (
                <ul>
                    <ListItem text="The reversing alarm should be checked for audible quality taking account of the noise environment of the site" />
                    <ListItem text="Flashing beacons must be checked that they are visible 360o around the vehicle" />
                    <ListItem text="Mirrors and cameras should be checked for adequate field of view (typically allow vision from the driver seat of all points 1m high and 1m away from each side of the machine)" />

                    <Li>
                        <Typography variant="title">
                            Safety Device Schedule
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Machine</th>
                                    <th>360 Warning beacons</th>
                                    <th>Reversing alarm</th>
                                    <th>Convex mirrors</th>
                                    <th>Movement alarm</th>
                                    <th>Convex mirror / CCTV</th>
                                </tr>
                                <tr>
                                    <td>Backhoe Loader</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>360 Excavator</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (no cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (with cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Off Road Dumper (> 7 Tonnes)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Loading Shovel</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Roller without cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Roller with cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Telescopic Handler</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Bulldozer</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Scraper</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Graders</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        pla_rev_cam: {
            name: "Reversing Camera",
            icon: pla_rev_cam,
            text: (
                <ul>
                    <ListItem text="Ensure cameras (CCTV) are positioned to give you easy and clear visibility over the required field of view" />
                    <Li>
                        <Typography variant="title">
                            Safety Device Schedule
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Machine</th>
                                    <th>360 Warning beacons</th>
                                    <th>Reversing alarm</th>
                                    <th>Convex mirrors</th>
                                    <th>Movement alarm</th>
                                    <th>Convex mirror / CCTV</th>
                                </tr>
                                <tr>
                                    <td>Backhoe Loader</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>360 Excavator</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (no cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Front Dumper (with cab)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Off Road Dumper (> 7 Tonnes)</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Loading Shovel</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Roller without cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Roller with cab and seat</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Telescopic Handler</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Bulldozer</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Scraper</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                                <tr>
                                    <td>Graders</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td>Yes</td>
                                    <td></td>
                                    <td>Yes</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        pla_sel_sui: {
            name: "Selection/ Suitability",
            icon: pla_sel_sui,
            text: (
                <ul>
                    <ListItem text="Before carrying out an activity the plant/equipment must be checked for it’s suitability for the task (e.g. Safe Working Load, capacity, voltage rating, reach capability, available accessories etc)" />
                </ul>
            )
        },
        pla_exa_ins: {
            name: "Examination & Inspection",
            icon: pla_exa_inp,
            text: (
                <ul>
                    <ListItem text="A person with the necessary mix of training, knowledge and experience must regularly examine the effectiveness of the controls" />
                    <ListItem text="Any defects or inadequacy must be noted and remedial action taken immediately." />
                    <Li>
                        <Typography variant="title">
                            For excavations, inspections must occur
                        </Typography>
                        <ol>
                            <ListItem text="At least once every day during which persons are working" />
                            <ListItem text="If > 2m deep, at the start of each shift" />
                            <ListItem text="After any event likely to have affected the strength or stability of the excavation or shoring" />
                            <ListItem text="After any accidental fall or rock, earth or other material" />
                            <ListItem text="At least once every 7 days where persons are not at work there" />
                            <ListItem text="The inspection should complete an AF3 form." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_acc_poi_ste: {
            name: "Access Points & Steps",
            icon: pla_acc_poi_ste,
            text: (
                <ul>
                    <ListItem text="Slips, trips and falls relating to vehicles is a leading cause of injury" />
                    <ListItem text="Should be clean, in good condition and slip resistant" />
                    <ListItem text="Should be big enough for at least the ball of the foot" />
                    <ListItem text="Have adequate lighting and check ground conditions before exiting" />
                    <ListItem text="Use both hands for entering and exiting, and maintain 3 points of contact" />
                    <ListItem text="Face the vehicle if safer" />
                </ul>
            )
        },
        pla_fir_gro: {
            name: "Firm Ground",
            icon: pla_fir_gro,
            text: (
                <ul>
                    <ListItem text="This must be assessed by a person with the proper mix of training, knowledge and experience. If the conditions are beyond the competence of the person, then expert advice must be sought." />
                    <ListItem text="The ground on which any plant, scaffold, or other equipment is to be used must be assessed to ensure it is capable of bearing the required load." />
                    <ListItem text="Preparation work on the ground may be required before the task can commence. If this is the case, then this work must be completed prior to the task, and the ground conditions re-assessed." />
                    <ListItem text="Ground must be level." />
                    <ListItem text="Loads cannot be placed closer to excavations edges than the excavation is deep in good ground/weather conditions. In poor ground/weather conditions this distance needs to be increased." />
                </ul>
            )
        },
        pla_loa_sta: {
            name: "Load Stability",
            icon: pla_loa_sta,
            text: (
                <ul>
                    <ListItem text="For lifting operations the load must be balanced, and properly secured to a sufficient number of anchor points to prevent rotation or displacement during transfer." />
                    <ListItem text="Keep centre of gravity as low as possible in all cases" />
                    <Li>
                        <Typography variant="title">
                            For vehicle transport, general advice is
                        </Typography>
                        <ol>
                            <ListItem text="Load balanced mid-axle line (equal left to right sides)" />
                            <ListItem text="Load secured against bulkhead of vehicle, or strapping rating = weight of load (braking)" />
                            <ListItem text="Rear strapping rated to 0.5 x weight of load (accelerating)" />
                            <ListItem text="Side strapping rated to 0.5 x weight of load (turning)" />
                            <ListItem text="For trailer transport load balanced over axle (hitch should be level)" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_gua_pto: {
            name: "Guards For PTO/ Machinery/ Equipment",
            icon: pla_pto_gua,
            text: (
                <ul>
                    <ListItem text="All plant and equipment must be operated in accordance with the manufacturer’s instructions. This includes the requirement for guards. Any powered moving or rotating part or shaft must be protected by a guard." />
                    <ListItem text="The plant or equipment cannot be operated where guards are missing." />
                    <ListItem text="The guard should be checked for condition and security of fit." />
                </ul>
            )
        },
        pla_rol_over_pro: {
            name: "Roll Over Protection",
            icon: pla_rol_ove_pro,
            text: (
                <ul>
                    <ListItem text="All ROPS must have a CE mark, with the European Standard number clearly marked, and be permanently and prominently located on the roll over bars." />
                    <ListItem text="The label should hold the name and address of the manufacturer, the identification number and it’s suitability (including the machine mass). If this information is missing you should contact the supplier immediately." />
                    <ListItem text="The driver must wear their seat belt while operating the machine." />
                    <ListItem text="The machine should not be used to transport passengers." />
                </ul>
            )
        },
        pla_loc_att: {
            name: "Locking Attachments",
            icon: pla_loc_att,
            text: (
                <ul>
                    <ListItem text="Attachments to construction plant must be secure at all times." />
                    <ListItem text="Locking pins must be used in accordance with the manufacturer’s instructions irrespective of how short or repetitive a task is." />
                    <ListItem text="The attachment manufacturer’s manual should be kept in the cab of the vehicle for reference." />
                    <ListItem text="Other operatives are not permitted within or underneath the radius of operation." />
                </ul>
            )
        },
        pla_saf_cli: {
            name: "Safety Clips",
            icon: pla_saf_cli,
            text: (
                <ul>
                    <ListItem text=" Should be used on all connections on pneumatic hose lines. This includes whip protection." />
                    <ListItem text="Alternatively, automatic cut-off valves can be used." />
                </ul>
            )
        },
        pla_for_cla_ext: {
            name: "Fork Clamps/ Extension",
            icon: pla_for_cla_ext,
            text: (
                <ul>
                    <ListItem text="Chains and Slings must NOT be wrapped around the forks of teleporters to lift a load" />
                    <Li>
                        <Typography variant="title">
                            When lifting a load
                        </Typography>
                        <ol>
                            <ListItem text="The forks must be removed and replaced with a crane extension with hook or shackle, or" />
                            <ListItem text="Suitable form clamps may be attached with a suitable hook or shackle." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_pum_con: {
            name: "Pump Connections",
            icon: pla_pum_con,
            text: (
                <ul>
                    <ListItem text="Each connection must be secured with the correct clip." />
                    <ListItem text="The manufacturer’s instructions must be followed" />
                </ul>
            )
        },
        pla_dea_man_han: {
            name: "Dead Mans Handle",
            icon: pla_dea_man_han,
            text: (
                <ul>
                    <ListItem text="The switch needs to be maintained in good working order" />
                    <ListItem text="The switch needs to be checked daily to ensure it is functioning correctly." />
                </ul>
            )
        },
        pla_saf_dril: {
            name: "Safe Driving",
            icon: pla_saf_dri,
            text: (
                <ul>
                    <ListItem text="You must have the relevant qualification to operate your vehicle." />
                    <ListItem text="You must be fit to operate your vehicle (with reference to fatigue, alcohol/drugs, illness/medical condition)." />
                    <ListItem text="You should visually check your vehicle prior to use for defects/ damage or that any load carried is secure. In any event, the vehicle must have a minimum of 1 daily vehicle walk around inspection for each day of use. This inspection should be recorded." />
                    <ListItem text="You cannot use a mobile phone while operating your vehicle" />
                    <ListItem text="You must use the seat belt provided. You cannot operate your vehicle while in a standing position. Adjust your seat for access to controls, visibility and comfort." />
                    <ListItem text="Ensure your mirrors/ cameras are giving you the correct field of view. Ensure that windows, cameras, and mirrors are kept clean." />
                    <ListItem text="Keep the cab clean and free of loose items." />
                    <ListItem text="If you are towing, you must check and ensure that your vehicle has the towing capacity for the weight to be towed (taking into account the weight already been carried on the vehicle). The maximum speed limit when towing a trailer is 80 km/h unless a lower speed limit is posted." />
                </ul>
            )
        },
        pla_sea_bel: {
            name: "Seat Belts",
            icon: pla_sea_bel,
            text: (
                <ul>
                    <ListItem text="Where seat belts have been provided, they must be worn" />
                    <ListItem text="As part of the daily walk around inspection, the condition of the seat belt should be checked to ensure it is in good working order" />
                </ul>
            )
        },
        pla_no_pas: {
            name: "No Passengers",
            icon: pla_no_pas,
            text: (
                <ul>
                    <ListItem text="Only the operator involved in operating the piece of plant should be on board." />
                    <ListItem text="When moving between work sites, the number of operatives to be carried is limited to the number of seats provided with seat belts." />
                    <ListItem text=" Additional operatives must not be carried. Operatives must not be used as a means to secure loads during transit." />
                </ul>
            )
        },
        pla_saf_wor_loa: {
            name: "Safe Working Load",
            icon: pla_saf_wor_loa,
            text: (
                <ul>
                    <ListItem text="You must know the safe working load for your appliance and each piece of lifting gear used. The actual safe working load will be the lowest value of any piece of gear used." />
                    <ListItem text="Before use, you must check that each lifting piece has a valid GA1 thorough inspection cert, and a valid GA2 weekly inspection cert." />
                    <ListItem text="You must know the weight of what you are lifting. This must be below the actual safe working load." />
                </ul>
            )
        },
        pla_saf_par: {
            name: "Safe Parking",
            icon: pla_saf_par,
            text: (
                <ul>
                    <ListItem text="All construction plant should be parked in a safe area when not in use (this may require a secure compound, depending on the risk assessment)." />
                    <ListItem text="The area should be level (if this is not possible, appropriate use must be made of chocks on the wheels)" />
                    <ListItem text="The hand brake must always be used." />
                    <ListItem text="Buckets, lifting gear, loads should be lowered to the ground" />
                    <ListItem text="Keys should be removed and securely stored." />
                    <ListItem text="Appropriate arrangements need to be provided for any staff/delivery/visitor parking. This should be segregated from the active works area, areas where construction plant is operating, or routes where plant/operatives are accessing the active works area." />
                </ul>
            )
        },
        pla_pla_lif: {
            name: "Plan Lift",
            icon: pla_pla_lif,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            All operatives involved in the lift (plant
                            operators, slinger/signaler, banksmen, assisting
                            operatives) need to know what controls will be used.
                            The plan should include
                        </Typography>
                        <ol>
                            <ListItem text="What lifting equipment is to be used and ensuring any lifting equipment has the necessary thorough examination (GA1 form) and weekly examination (GA2 form)" />
                            <ListItem text="Know what items are to be lifted and their weight, dimensions and centre of gravity" />
                            <ListItem text="Who will be directing the lift, and what communication method/ instructions will be used." />
                            <ListItem text="What the path of the lift will be and what exclusion zones are in place." />
                            <ListItem text="A written method statement may be required and this may include sketches of the path and load attachment points/ methods." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_sit_spe_con: {
            name: "Site Speed Controls",
            icon: pla_sit_spe_con,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            It is generally not advisable to solely rely on
                            posting speed limits to control speed. Speed control
                            is best achieved by the physical properties of the
                            site such as
                        </Typography>
                        <ol>
                            <ListItem text="Narrower lane widths" />
                            <ListItem text="Use of Stop/Go systems or Temporary Traffic Signals. On public roads this will require the permission of the road authority and consultation with the Gardaí." />
                            <ListItem text="Convoy vehicles." />
                        </ol>
                    </Li>
                    <ListItem text="The use of chicanes and ramps may be considered subject to them not introducing other risks for the operation of the plant." />
                    <Li>
                        <Typography variant="title">
                            While reducing site speed ≤ 30km/h will
                            significantly reduce the severity if an incident
                            were to occur, the overall risk can be greatly
                            reduced by reducing the likelihood of an incident
                            actually occurring. This can be achieved by
                        </Typography>
                        <ol>
                            <ListItem text="Providing segregation between your workers and traffic in the form of physical barriers or safety zones" />
                            <Li>
                                <Typography variant="title">
                                    Ensuring good visibility
                                </Typography>
                                <StyledTable>
                                    <tbody>
                                        <tr>
                                            <td>30 km/h</td>
                                            <td>35m</td>
                                        </tr>
                                        <tr>
                                            <td>50 km/h</td>
                                            <td>60m</td>
                                        </tr>
                                        <tr>
                                            <td>60 km/h</td>
                                            <td>90m</td>
                                        </tr>
                                        <tr>
                                            <td>80 km/h</td>
                                            <td>120m</td>
                                        </tr>
                                        <tr>
                                            <td>100 km/h</td>
                                            <td>160m</td>
                                        </tr>
                                    </tbody>
                                </StyledTable>
                            </Li>
                            <ListItem text="On sites where there are a large number of complex plant maneuvers in close proximity to workers, 20 km/h should be implemented." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_che_lif_gea: {
            name: "Check Lifting Gear",
            icon: pla_che_lif_gea,
            text: (
                <ul>
                    <Typography variant="title">
                        Any chain, sling, rope, hook, shakle or eye bolt must be
                        checked prior to lift.
                    </Typography>
                    <Li>
                        <Typography variant="title">
                            {" "}
                            It must have a statutory inspection by a competent
                            person every 6 months. This may be extended to 12
                            months for
                        </Typography>
                        <ListItem text="Tailboards, support equipment, cranes, forklift/telehandler as long as goods only, winches." />
                    </Li>
                    <ListItem text="The gear must have the safe working load identified on it." />
                    <ListItem text="A visual inspection must identify that the gear is in good condition prior to any use. Damaged items must be brought out of use and clearly marked “out of Service”." />
                </ul>
            )
        },
        pla_exc_che_val: {
            name: "Excavator Check Valves",
            icon: pla_exc_che_val,
            text: (
                <ul>
                    <ListItem text="All hydraulic machines > 1 Tonne lifting capacity must be fitted with check valves to the cylinders used for lifting." />
                    <ListItem text="The operator must ensure the safe working load of the machine is not exceeded (including the lift radii limits)" />
                </ul>
            )
        },
        pla_cra: {
            name: "Crane",
            icon: pla_cra,
            text: (
                <ul>
                    <ListItem text="The crane must be properly and regularly maintained." />
                    <ListItem text="The crane and lifting gear must be selected to match job requirements" />
                    <ListItem text="The crane operator must be trained and have a CSCS card (for tower cranes). The operation must be directed by a CSCS Slinger Signaller. The crane operator must have direct view of the load or signaller when undertaking lifting operations." />
                    <ListItem text="The operator must follow the manufacturers operating procedures. This manual must be available on site for the operator to reference." />
                    <ListItem text="The crane must be placed on firm, level ground with sufficient bearing capacity" />
                    <ListItem text="Special care, and additional controls, will be required when working in the vicinity of overhead lines." />
                    <ListItem text="Wind speeds must be below that specified by the manufacturer for the operation being undertaken" />
                    <ListItem text=" The path of the load must be planned to prevent swinging loads passing over site operatives. Operatives not involved with the load must remain outside of the fall zone." />
                </ul>
            )
        },
        pla_cra_cor: {
            name: "Crane Co-Ordination",
            icon: pla_cra_cor,
            text: (
                <ul>
                    <ListItem text="One person must be appointed to have overall control of the lifting operation." />
                    <ListItem text="Strict controls, including individual crane working zone limits, need to be established and implemented on site to ensure loads (or crane parts) do not come into contact." />
                </ul>
            )
        },
        pla_man_cra: {
            name: "Man Cradle",
            icon: pla_man_cra,
            text: (
                <ul>
                    <ListItem text="Should only be used where it is not possible to use scaffolding or MEWPS." />
                    <ListItem text="The cradle must be rigged to the crane by a competent person, and certified. The crane cannot have the free-fall system engaged." />
                    <ListItem text="The cradle can only be used to transport the required operatives, their tools and material necessary to complete the task. They cannot be used to transport bulk materials." />
                    <ListItem text="Operatives must be attached to a fall-arrest system, with the anchor point at the hook block on the crane." />
                </ul>
            )
        },
        pla_sla_lif_gea: {
            name: "Slab Lifting Gear",
            icon: pla_sla_lif_gea,
            text: (
                <ul>
                    <ListItem text="Slab lifting gear must be suitable for the task and have sufficient safe working load. Special purpose lifting gear should be used for the slabs and these will require thorough and weekly inspections." />
                </ul>
            )
        },
        pla_sli_sig: {
            name: "Slinger/ Signaller",
            icon: pla_sli_sig,
            text: (
                <ul>
                    <ListItem text="A CSCS Slinger/ Signaller must be used where loads are lifted (by crane, excavator, telehandler, or loader) and the appliance operator cannot observe the full path of the load, to give safe direction is given to the operator. They should be easily identifiable, normally wearing distinctive PPE. This " />
                    <Li>
                        <Typography variant="title">
                            The Slinger/ Signaller is responsible for selection
                            and use of lifting gear and the loads to be lifted
                            by them. This means
                        </Typography>
                        <ol>
                            <ListItem text="Being properly constructed and of the correct capacity, length and size for the load to be lifted" />
                            <ListItem text="Be marked to show the safe working load and identification" />
                            <ListItem text="Have a current, thorough examination report, and where appropriate, a current test certificate" />
                            <ListItem text="Be suitable for the intended purpose." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_veh_pla_con: {
            name: "Vehicle/ Plant Controller",
            icon: pla_veh_pla_con,
            text: (
                <ul>
                    <ListItem text="Also known as a Vehicle Banksman." />
                    <ListItem text="Reversing vehicles are a significant risk on construction sites. (about 25% of all deaths are caused by this)" />
                    <ListItem text="Vehicle controllers should only be used if it is not reasonably practicable to physically segregate workers on foot/public from vehicle maneouvres, or use one way/drive through systems that avoid the need for reversing." />
                    <ListItem text="Work must be organised and planned to minimize the need for reversing. The reversing areas should be planned out, clearly marked, and known to all workers/drivers. For fixed sites, the use of vehicle stop-blocks should be considered." />
                    <ListItem text="Workers not directly involved in the reversing operation must be kept out of the area, while reversing is taking place." />
                    <ListItem text="The driver cannot begin reversing until the Vehicle Controller gives positive confirmation that it is safe to do so. Before giving such a signal, the Vehicle Controller must check that it is safe, and all unnecessary workers are clear of the area." />
                    <ListItem text="Vehicle Controllers should be trained and use standard signals. Drivers of vehicles must also know the signals that are used, this may require induction before arriving/beginning duties on site. The driver may also be required to leave their cab, check the area to confirm space and control requirements with the Vehicle Controller prior to beginning reversing. This will depend on site arrangements." />
                    <ListItem text="The Vehicle Controller must be positioned in a safe location, outside of vehicle reversing paths, and be clearly visible to drivers at all times during signaling." />
                    <ListItem text="In high risk scenarios, OR if practicable in all other scenarios, the Vehicle Controller should be in 2-way radio communication with drivers. This may include having a “floating” handset, that is given to drivers during the reversing operation." />
                    <ListItem text="The Vehicle Controller should wear distinctive high visibility PPE to make them easily identifiable to drivers." />{" "}
                    <ListItem text="Any reversing vehicle MUST STOP IMMEDIATELY if the vehicle controller is not in view/radio contact lost." />
                </ul>
            )
        },
        pla_2_way_rad: {
            name: "2-Way Radios",
            icon: pla_2_way_rad,
            text: (
                <ul>
                    <ListItem text="Radios should be fully charged for the beginning of each shift, and a back-up radio should also be provided" />
                    <ListItem text="Only one operator can talk at a time by holding down talk button, talk while button held, when finished release talk button" />
                    <ListItem text="Operators should identify who is talking, who they are talking to and, give clear and concise instructions. They should finish with the work “Over”" />
                    <ListItem text="Radios should be tested 2 times daily for battery and agreed channel" />
                    <ListItem text="Mobile Phones should not be used as a replacement for 2-way radios	" />
                </ul>
            )
        },
        pla_exc_zon: {
            name: "Exclusion Zone",
            icon: pla_exc_zon,
            text: (
                <ul>
                    <ListItem text="Operatives should not work under an area where loads are being lifted or within the working radii of a job." />
                    <ListItem text="Operatives should keep a safe distance from working plant (at least 2 machine lengths at any time)." />
                    <ol>
                        <Typography variant="title">
                            Operatives on foot must clearly know where such
                            zones are and how they are demarked
                        </Typography>
                        <ListItem text="Barriers" />
                        <ListItem text="Markings/ Signage" />
                        <ListItem text="Method of Work" />
                    </ol>
                </ul>
            )
        },
        pla_veh_tur: {
            name: "Vehicle Turning/ Reversing Area",
            icon: pla_veh_tur,
            text: (
                <ul>
                    <ListItem text="Reversing vehicles are a significant risk on construction sites. (about 25% of all deaths are caused by this)" />
                    <Li>
                        <Typography variant="title">
                            Where possible, the need for reversing should be
                            minimized by;
                        </Typography>
                        <ol>
                            <ListItem text="Planning separate routes in and out of the site into a one way system, to avoid the need to reverse" />
                            <ListItem text="introducing a one-way/drive through system on site and providing adequate segregated turning areas, away from the works area, where reversing will not be required. " />
                            <ListItem text="Where space is more limited segregated reversing areas, away from the works area, should be provided." />
                        </ol>
                    </Li>
                    <ListItem text="Delivery drivers, along with drivers on site, need to be made aware of the arrangements, either by signage or direct instruction prior to arrival." />
                    <ListItem text="These areas need adequate visibility for the drivers and be adequately lit." />
                    <ListItem text="Risks are increased where there are a large number of material deliveries. " />
                    <ListItem text="This area should be segregated from the public and operatives on foot." />
                    <ListItem text="Where provided, these are the only area where such manoeuvres should occur." />
                </ul>
            )
        },
        pla_wor_on_foo: {
            name: "Workers On Foot Route",
            icon: pla_wor_on_foo,
            text: (
                <ul>
                    <ListItem text="Workers will be segregated from construction plant" />
                    <ListItem text="If they are in close proximity, barriers will be provided" />
                    <ListItem text="Dedicated and clearly marked routes will be provided" />
                </ul>
            )
        },
        pla_del_tra: {
            name: "Delivery/ Transport",
            icon: pla_del_tra,
            text: (
                <ul>
                    <ListItem text="Deliveries should be planned to arrive on site at the correct time and in the correct order." />
                    <ListItem text="Delivery drivers need to be aware of the delivery locations, safe parking and vehicle turning arrangements. An assigned operative wearing distinctive PPE is advised to direct delivery drivers." />
                    <ListItem text="Loads should be checked prior to unloading in case any items became loose during transit." />
                    <ListItem text="Where multiple unloading are undertaken, loads must be re-secured between stopping points." />
                </ul>
            )
        },
        pla_no_tip: {
            name: "No Tipping",
            icon: pla_no_tip,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>
                                        Distance from edge of Hazard Zone to
                                        overhead line
                                    </th>
                                </tr>
                                <tr>
                                    <td>LV, 10kV, 20kV, 38kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV, 220kV, 400kV</td>
                                    <td>10.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The Exclusion Zone around live wires must never be
                            breached.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>Radius around live wire</th>
                                </tr>
                                <tr>
                                    <td>Insulated LV</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>Bare LV, 10kV, 20kV, 38kV</td>
                                    <td>3.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV</td>
                                    <td>4.5m</td>
                                </tr>
                                <tr>
                                    <td>220kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>400kV</td>
                                    <td>8.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                    <ListItem text="No Tip Zones can be exclusively used for road surfacing operations. These are set perpendicular to the road direction, such that no point of the no tip zone is closer than 3m to the overhead line. They must be clearly marked and provided with a dedicated banksman in direct communication with the plant operator(s)." />
                </ul>
            )
        },
        pla_oh_lin: {
            name: "Over Head Lines",
            icon: pla_ove_hea_lin,
            text: (
                <ul>
                    <ListItem text="The ESB should be consulted to establish the voltages present." />
                    <ListItem text="Follow the practice outlined in “Avoiding Danger from Overhead Electricity Lines”" />
                    <Li>
                        <Typography variant="title">
                            The Hazard Zone alongside overhead lines should be
                            isolated from plant activity by physical means
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>
                                        Distance from edge of Hazard Zone to
                                        overhead line
                                    </th>
                                </tr>
                                <tr>
                                    <td>LV, 10kV, 20kV, 38kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV, 220kV, 400kV</td>
                                    <td>10.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            The Exclusion Zone around live wires must never be
                            breached.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Voltage</th>
                                    <th>Radius around live wire</th>
                                </tr>
                                <tr>
                                    <td>Insulated LV</td>
                                    <td>1.0m</td>
                                </tr>
                                <tr>
                                    <td>Bare LV, 10kV, 20kV, 38kV</td>
                                    <td>3.0m</td>
                                </tr>
                                <tr>
                                    <td>110kV</td>
                                    <td>4.5m</td>
                                </tr>
                                <tr>
                                    <td>220kV</td>
                                    <td>6.0m</td>
                                </tr>
                                <tr>
                                    <td>400kV</td>
                                    <td>8.0m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Crossing points for plant underneath overhead lines should be provided using “goalposts”. These should be max 9m width and 4.2m max height." />
                    <ListItem text="No Tip Zones can be exclusively used for road surfacing operations. These are set perpendicular to the road direction, such that no point of the no tip zone is closer than 3m to the overhead line. They must be clearly marked and provided with a dedicated banksman in direct communication with the plant operator(s)." />
                </ul>
            )
        },

        pla_vib_con_ser: {
            name: "Vibration Controls/ Service Duration",
            icon: pla_vib_con,
            text: (
                <ul>
                    <ListItem text="These controls are applicable when operatives are using any vibrating tools, equipment or plant. The main risk is to health from long term exposure." />
                    <ListItem text="Any handles, or vibration damping attachments provided must be used by operatives" />
                    <ListItem text="Adjust any seat so that you are comfortable and it supports your lower back and so you can see clearly/operate without having to stretch, twist or lean. Avoid bad posture (slumping in your seat), constantly leaning forward or sideways. Take regular breaks, don’t jump off the machine (unless contact with electricity)" />
                    <Li>
                        <Typography variant="title">
                            For guidance only, maximum operation times/ day
                            should be limited to
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Tool</th>
                                    <th>Typical Tool</th>
                                    <th>Modern Tool</th>
                                </tr>
                                <tr>
                                    <td>Road Breaker</td>
                                    <td>1 hour 23 min (12 m/s2)</td>
                                    <td>8 hours (5 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Demolition Hammer</td>
                                    <td>0 hour 53 min (15 m/s2) </td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Hammer Drill</td>
                                    <td>2 hour 28 min (9 m/s2)</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Scabbler (hammer)</td>
                                    <td>0 hour 13 min (30 m/s2)</td>
                                    <td />
                                </tr>
                                <tr>
                                    <td>Angle Grinder (large)</td>
                                    <td>12 hour 30 min (4 m/s2)</td>
                                    <td>12 hour 30 min (4 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Sander</td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                    <td>3 hour 8 min (8 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Chainsaw</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                    <td>5 hour 33 min (6 m/s2)</td>
                                </tr>
                                <tr>
                                    <td>Brushcutter</td>
                                    <td>2 hour 28 min (9 m/s2)</td>
                                    <td>8 hours (5 m/s2)</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Vibrating Roller (seat adequately damped): 8 hours" />
                </ul>
            )
        },
        pla_dus_muc_cle: {
            name: "Dust/ Muck/ Cleaning & Removal",
            icon: pla_dus_muc_cle_rem,
            text: (
                <ul>
                    <ListItem text="Dust and muck are a nuisance for workers and the public." />
                    <ListItem text="Hand brushes may be used for smaller areas" />
                    <ListItem text="Equipment of plant should be used for larger areas" />
                    <ListItem text="Heavy soiling will require a cleaning action (with brushes, most surfaces should NOT use steel type brushes)" />
                    <ListItem text="During periods of dry weather, where dust is a problem, the area may be dampened (generally do NOT over wet)" />
                </ul>
            )
        },
        pla_veh_mov: {
            name: "Vehicle Movement",
            icon: pla_veh_mov,
            text: (
                <ul>
                    <ListItem text="Small vehicles, and mobile equipment may be carried on general freight vehicles." />
                    <ListItem text="Loads with a high centre of gravity should only be transported on vehicles with low platform heights. " />
                    <ListItem text=" Heavy plant should be moved on appropriate low loaders." />
                    <ListItem text="The load should achieve the correct distribution and NOT exceed the permitted axle weight. " />
                    <ListItem text="A minimum of 4 lashings should be used, with 4 separate anchorage points. Top over lashings across the plant driver cabin or covers on plant are NOT recommended." />
                    <ListItem text="The plant & attachments must be firmly anchored to the low loader, with excavator/crane jibs lowered. " />
                    <ListItem text="The plant should be restrained against forward, backward and sideways movement by chain or webbing lashing securely attached to anchorage points on the loader. All lashings should incorporate some form of tensioning device." />
                    <ListItem text="When calculating lashing strength, you must use the lashing capacity and NOT the breaking force. " />
                    <ListItem text="Forward movement of the plant should be restricted achieving a lashing capacity = weight of the plant/containment or blocking." />
                    <ListItem text="Rearward movement of the plant should be restricted achieving a lashing capacity = 0.5 x weight of the plant/ containment or blocking" />
                    <ListItem text="Sideways movement of the plant should be restricted achieving a lashing capacity = 0.5 x weight of the plant" />
                    <ListItem text="Straps must comply with EN12195-2. They must have a hand operated ratchet tensioner. The length of the strap must be sufficient." />
                    <ListItem text="Chains must comply with EN12195-3. The use of spring links is NOT recommended." />
                    <ListItem text=" Chain Lashings and Straps must NOT be used to secure the same load due to differing elongation behaviours." />
                    <ListItem text="All straps/chains must be visually inspected before use and be suitable for the lashing point to be used." />

                    <Li>
                        <Typography variant="title">
                            Loads can be restrained by two basic methods,{" "}
                        </Typography>
                        <ol>
                            <ListItem text="“Tie-down” largely relies on the weight of load on the loader floor. The load has tie-down lashings to ensure firm contact with floor." />
                            <ListItem text="“Direct restraint” uses the transporter body to contain the load; headboards, tailgates to block the load; or twist locks or direct lashing to attach the load." />
                        </ol>
                    </Li>
                    <ListItem text="The recommended angle for direct lashings is 1 in 2 or 25o to the horizontal" />
                    <Li>
                        <Typography variant="title">
                            You must NOT rely on the weight of the load alone to
                            hold it in place
                        </Typography>
                        <ol>
                            <ListItem text="All Plant and Machinery should use direct lashing, and/or blocking. Wherever possible the plant should be against the headboard or gooseneck of the vehicle/trailer body. If loaded away from this point, headboards must be strong enough to prevent the load from moving." />
                            <ListItem text="Loads should not be loaded above the height of the headboard unless precautions have been taken to stop it moving forward." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_veh_rec: {
            name: "Vehicle Recovery",
            icon: pla_veh_rec,
            text: (
                <ul>
                    <ListItem text="Only appropriate plant should be used to rescue vehicles." />
                    <ListItem text="Tows must be attached to approved towing points." />
                    <ListItem text="Do not use back actors, excavator booms, lifting arms (unless there is an emergency)" />
                </ul>
            )
        },
        pla_tel: {
            name: "Teleporter",
            icon: pla_tel,
            text: (
                <ul>
                    <ListItem text="Operators of teleporters must have a valid CSCS Telescopic Handler Card" />
                    <ListItem text="The Safe Working Load needs to be specified, including different Safe Working Loads for different configurations of the machine. You are not permitted to lift loads beyond this weight." />
                    <ListItem text="Jib extensions for safe working loads must be clearly marked on the machine, or be clearly displayed as a table in the driver cab." />
                    <ListItem text=" Hydraulic machines rated with a lift capacity greater than 1 Tonne must have check valves fitted or have an equivalent fall arrest system." />
                    <ListItem text="Machines rated with a lift capacity greater than 1 Tonne must have a safe load indicator, or rated capacity indicator fitted." />
                    <ListItem text=" Must have a certificate of thorough inspection (GA1: 6 months when lifting persons; 12 months if ONLY goods) and weekly inspection (GA3). The certificate must be available at the works site. A thorough inspection must also be carried out following a substantial alteration or repair, before the machine is used." />
                    <ListItem text="Telehandlers must have a reversing alarm, flashing beacons and be fitted with CCTV or convex mirrors or a combination of both." />
                    <ListItem text="The area where telehandlers are being used needs to segregate pedestrian/workers on foot, from plant movements. This should take into account the hazard area in the event of the telehandler overturning. Site speed control should be used in any event." />
                    <ListItem text="Telehandlers normally require prepared, flat, graded surfaces to operate safely. Rough-terrain lift handlers will still have strict limits that must be observed." />
                    <ListItem text="Moving with a raised load is dangerous and should be avoided at all times." />
                </ul>
            )
        },
        pla_gra_lor: {
            name: "Grab Lorry",
            icon: pla_gra_lor,
            text: (
                <ul>
                    <ListItem text="Operators must be trained" />
                    <ListItem text="The device should be CE marked, and have a report of thorough examination at least every 12 months, and kept within the cab of the vehicle." />
                    <ListItem text="Operators are required to carry out daily pre-use checks." />
                    <ListItem text="A weekly inspection is also required with details recorded on a GA2 Form, and kept within the cab of the vehicle." />
                    <ListItem text=" The operator must assess whether they can complete the lift on their own, or whether they will require a banksman of slinger/ signaller." />
                    <ListItem text="The area must be of sufficient size, with sufficient clearances to allow the lorry to set up without risk of entrapment." />
                    <ListItem text=" The operator must assess the load bearing ability of the ground in accordance with the conditions prescribed by the manufacturer and operate accordingly. Any additional measures, such as sleepers, mats or plates should only be used within the operators training, knowledge and experience. If the ground conditions are beyond the competence of the operator, they must seek expert help." />
                    <ListItem text="All lifting accessories must be rated and marked for the load and also inspected. During lifting, slings must be protected from damage by sharp edges on the load. The slinging method must be suitable for the size and shape of the load." />
                    <ListItem text="Other operatives are not permitted within or under the load path during the lift." />
                    <ListItem text="The operator must wear a hard hat, high visability clothing and safety footwear when operating" />
                </ul>
            )
        },
        pla_blo_gra: {
            name: "Block Grab and Nets",
            icon: pla_blo_gra,
            text: (
                <ul>
                    <ListItem text="Block grabs come under the definition of lifting gear" />
                    <ListItem text="The ground must be stable and level enough to lift the load" />
                    <ListItem text="There must be a certificate of thorough inspection and daily condition inspection" />
                    <ListItem text="You must have a slinger signaller present" />
                    <ListItem text="A net should be used around the blocks being lifted to catch any loose blocks." />
                </ul>
            )
        },

        pla_rem_con: {
            name: "Remote Control",
            icon: pla_rem_con,
            text: (
                <ul>
                    <ListItem text="The remote control operator must always keep the transmitter key in their possession, to prevent unauthorized use. Alternatively the transmitter key must be kept in secure storage." />
                    <ListItem text=" If the remote panel is belt fitted, the belt must be worn before switching on, to prevent accidental operation. It must be switched off before removing the belt." />
                    <ListItem text="The remote controlled equipment should be fitted with an automatic cut-off system in the event that signal from the remote control is lost." />
                    <ListItem text="The remote control must be maintained, and operated in accordance with the manufacturer’s instructions." />
                </ul>
            )
        },
        pla_con_pum: {
            name: "Concrete Pump",
            icon: pla_con_pum,
            text: (
                <ul>
                    <ListItem text="The pump must be properly and regularly maintained. All guards must be in place." />
                    <ListItem text="The pump must be operated by a trained operative in accordance with the manufacturers, equipment owners safe system of work" />
                    <ListItem text="The pump must be sized to match the job requirements" />
                    <ListItem text="Special care, and additional controls, will be required when working in the vicinity of overhead lines." />
                    <ListItem text="Wind speeds must be below that specified by the manufacturer" />
                    <ListItem text="Any required sole plates must be placed on stable, firm and level ground, with sufficient bearing capacity." />
                    <ListItem text="A signaller will be required where the pump operator cannot see the concrete placing gang. The signals must be agreed between the placing gang, signaller and pump operator." />
                    <ListItem text="Site personnel must NEVER attempt to open a delivery pipeline under pressure. Blockages will be taken care of by the pump operator by, using a stopping and reversing the pump procedure/ or identifying the location of the blockage." />
                    <ListItem text="Securing pins must be used on all pipe couplings. A safety strap/ chain should be used on the tip hose in the event of pin failure" />
                    <ListItem text="Concrete must be prevented from falling out of the hose or boom over site operatives." />
                    <ListItem text="The boom CANNOT be used as a means of hoisting/ lifting equipment or personnel." />
                    <ListItem text="If left unattended, the boom and pump must be isolated." />
                    <ListItem text="Hard Hats (EN 397), Safety Footwear (EN 20345), overalls, Eye protection (Class S EN 166), Hearing protection (EN 352) Impervious gaunlets/ gloves to EN 374-2 must be worn." />
                </ul>
            )
        },
        pla_con_ski: {
            name: "Concrete Skips",
            icon: pla_con_ski,
            text: (
                <ul>
                    <ListItem text=" The skip can only be operated using the discharge handle as intended. Hands must be kept away from any other moving part of pinch point." />
                    <ListItem text="Hard Hats (EN 397), Safety Footwear (EN 20345), overalls, Eye protection (Class S EN 166), Hearing protection (EN 352) Impervious gaunlets/ gloves to EN 374-2 must be worn." />
                    <ListItem text="Ride on Skips can only be used when there is a written site specific methodology in place and the operative follows that instruction." />
                </ul>
            )
        },
        pla_wat_bow: {
            name: "Water Bowser",
            icon: pla_wat_bow,
            text: (
                <ul>
                    <ListItem text="Where dust is being generated by site vehicles, particularly during dry spells of weather, water bowsers should be used to “wet” the surface." />
                    <ListItem text="The rate of spray should be just enough to wet the surface and not cause excess amounts of water (that may lead to secondary hazards)." />
                    <ListItem text="During frosty/icy weather, bowsers should not be used. Consider using non-steel type road brushes in these conditions, and time operations such that any salt/grit spread is NOT being swept up. Co-ordinate with the local roads authority if required." />
                </ul>
            )
        },
        pla_gla_suc: {
            name: "Glazing/ Suction",
            icon: pla_gla_suc,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            The equipment must be inspected at the beginning of
                            each shift, in particular
                        </Typography>
                        <ol>
                            <ListItem text="The rotary vacuum seal" />
                            <ListItem text="The pump and valve" />
                            <ListItem text="Tubes (wire reinforcement is subject to fatigue wear. Tubes in general are subject to ageing wear)" />
                            <ListItem text="Rubber cups" />
                        </ol>
                    </Li>
                    <ListItem text="Ensure that the load material has sufficient strength to carry the weight of the load." />
                    <ListItem text="Ensure that any packaging surrounding (carrying) the load is adequate for the load (not forgetting the underside of the packaging)" />
                    <ListItem text="This equipment cannot be used where loads will pass over operatives. In general loads should be moved at the minimum height feasible." />
                    <ListItem text="Only one piece is to be lifted at a time. Follow the manufacturer’s instructions. Do not exceed the SWL." />
                </ul>
            )
        },
        pla_ker_mac_pin: {
            name: "Kerbing Machine/ Pinch/ Fall Controls",
            icon: pla_ker_mac,
            text: (
                <ul>
                    <ListItem text="Guards must be in place, securely attached and in good condition." />
                    <ListItem text="Ladders, gantries, safety rails, and handhold/ foothold points must be in good condition." />
                    <ListItem text="All equipment lights need to be operational." />
                    <ListItem text="Emergency Stop buttons need to be operational and checked daily." />
                    <ListItem text="Operatives should be trained." />
                    <ListItem text="Operatives should wear hard hats, ear protection, and safety boots during operation." />
                </ul>
            )
        },

        pla_roa_pla_pin: {
            name: "Road Planer/ Pinch/ Fall Controls",
            icon: pla_roa_pla_pin_fal,
            text: (
                <ul>
                    <ListItem text="Risks include elevated platforms and conveyors." />
                    <ListItem text="Must be well maintained with all guards, railings, steps in place, in good condition and clean." />
                    <ListItem text="Sufficient guarding must be provided for ejecting materials" />
                    <ListItem text="Ensure adequate protection from overhead lines." />
                    <ListItem text="Operatives must be trained on the use of the machine." />
                </ul>
            )
        },

        pla_roc_bre_cab_pro: {
            name: "Rock Breaker/ Cab Protection",
            icon: pla_roc_bre_cab_pro,
            text: (
                <ul>
                    <ListItem text="The driver cab should be fitted with a protective cage." />
                    <ListItem text="The cage should be inspected regularly for wear and damage." />
                    <ListItem text="All fittings and attachments must be secure, fitted by a competent person in accordance with the manufacturer’s instructions, and free from defects." />
                </ul>
            )
        },
        pla_cru_pla: {
            name: "Crushing Plant",
            icon: pla_cru_pla,
            text: (
                <ul>
                    <ListItem text="The plant must be regularly and properly maintained." />
                    <ListItem text="All guards must be in place and inspected daily for damage and to ensure they are secure. This includes guards to prevent operative entanglement, or crushing material ejection." />
                    <ListItem text=" Operatives must be trained in the plant use" />
                    <ListItem text="Eye protection, hearing protection, safety boots and hard hat must be worn." />
                </ul>
            )
        },
        pla_gas_bot_sto: {
            name: "Gas Bottle Storage",
            icon: pla_gas_bot_sto,
            text: (
                <ul>
                    <ListItem text="Cylinders must be upright during handling, transport, storage and use" />
                    <ListItem text="If they have been laid down, they must be placed upright for a minimum of 30 minutes before use" />
                    <ListItem text="Protect cylinders from sunlight" />
                    <ListItem text="Cannot be toppled, dropped or rolled on their side" />
                    <ListItem text="Do NOT use valves as lifting points" />
                    <ListItem text="If leak is detected, stop leak if possible without personal risk. Keep people away. Isolate and remove sources of ignition. Ensure ventilation." />
                </ul>
            )
        },
        pla_cem_mix: {
            name: "Cement Mixer",
            icon: pla_cem_mix,
            text: (
                <ul>
                    <ListItem text=" Operatives should be trained in the use of the cement mixer" />
                    <ListItem text="Ensure the mixer is on stable, level ground and the wheels are braced" />
                    <ListItem text=" Ensure all machine guards are in place, and operatives hands and arms are kept out of the mixer at all times. The mixer must be turned off before cleaning the inside by hand." />
                    <ListItem text=" Use PPE and place the machine to avoid dust blowing onto operative" />
                </ul>
            )
        },
        pla_sti: {
            name: "Stillages",
            icon: pla_sti,
            text: (
                <ul>
                    <ListItem text="Stillages must be in good condition." />
                    <ListItem text="Loads to be lifted must be well secured." />
                    <ListItem text="You should conduct a test lift first (just clear of the ground) to assess both the security and the load stability." />
                </ul>
            )
        },
        pla_ski_bin: {
            name: "Skips/ Bins",
            icon: pla_ski_bin,
            text: (
                <ul>
                    <ListItem text="All lifting lugs and lifting eyes should have their safe working load clearly visible. The Safe Working Load must be checked before lifting commences. The skip, including lifting points, panels, and bars, should be visually checked prior to any lift." />
                    <ListItem text="If used as lifting gear, the skip/bin must be certified." />
                    <ListItem text="If placed on a public footpath or road, they will need traffic/pedestrian management, and will generally require a license from the road authority." />
                    <ListItem text="The skip should be loaded with waste materials evenly across from front to back. Materials should not protrude beyond the normal dimensions of the skip." />
                </ul>
            )
        },
        pla_gra_cut: {
            name: "Grass Cuttings",
            icon: pla_gra_cut,
            text: (
                <ul>
                    {" "}
                    <ListItem text="You need to read, understand and follow the manufacturer’s operating manual. Know how the controls work and how to stop the machine quickly." />
                    <ListItem text="The machine should be properly and regularly maintained, including the blade sharpened. Thin or worn blades need to be replaced." />
                    <ListItem text="The machine must be switched off, and the engine cool during fueling. Use a clean refuelling technique to avoid spillages. Do not smoke. The machine can only be started at least 8m from the refuelling point. Petrol must be stored in a cool, dry well ventilated area, away from direct sunlight or heat source." />
                    <ListItem text=" Check the area to be cut before-hand for foreign materials." />
                    <ListItem text="Keep others away from your operation." />
                    <ListItem text="Wear long trousers, close fitting cltohes and non-slip safety footwear. Wear hearing and eye protection." />
                </ul>
            )
        },
        pla_str: {
            name: "Strimming",
            icon: pla_str,
            text: (
                <ul>
                    <ListItem text="Before starting, assess the area to be strimmed for firmness, slope, trip hazards, rubbish (including syringes), animals (hedgehogs, nests), and proximity to traffic, services, water or other hazards. Ensure necessary preparations are complete and appropriate controls are put in place. The area needs to be well lit." />
                    <ListItem text="Locate and ensure you are familiar with all the machine controls" />
                    <ListItem text="Check for loose/missing nuts, bolts and screws. Tighten/replace as necessary." />
                    <ListItem text="Inspect fuel lines, tank and area around carburetor for fuel leaks. Ensure fuel cap is fully tightened." />
                    <ListItem text="Ensure all guards (including debris shield) are fitted, secure and properly placed." />
                    <ListItem text="You must use the strimmer using both hands on the bar handle/U-handle, and while attached to a properly adjusted shoulder harness. Adjust the handles for comfort and balance." />
                    <Li>
                        <Typography variant="title">
                            Select the correct cutting tool for the task
                        </Typography>
                        <ol>
                            <ListItem text="Nylon trimmer line must have the correct diameter for the nylon head fitting" />
                            <ListItem text="The blade must be attached as per the manufacturer’s instructions (e.g. locknut) with the teeth pointing in the right direction." />
                        </ol>
                    </Li>
                    <ListItem text="When starting, ensure the machine is in a clear area so the line or blade cannot contact the ground or other obstruction" />
                    <ListItem text="Ensure other people and animals are a safe distance away from ejecting materials." />
                    <ListItem text="Maintain proper balance and secure footing. Do not work on slippery, uneven or unstable surfaces." />
                    <ListItem text="Maintain a straight wrist position. Avoid using your wrist in a bent, extended or twisted position." />
                    <ListItem text="Keep the tool clear of fences, wires, posts and rocks." />
                    <ListItem text="Shut down immediately if the unit starts to shake or vibrate." />
                    <ListItem text="Disconnect the spark plug before you work on the unit or leave it unattended." />
                    <ListItem text="Take care when refueling to avoid spilling fuel on hot surfaces." />
                    <ListItem text="After shutting down the engine, keep fingers/feet away from the cutting tool until the rotation stops" />
                    <ListItem text="After use, remove foreign material from around the engine, cutting tool and guards" />
                    <Li>
                        <Typography variant="title">You must wear</Typography>
                        <ol>
                            <ListItem text="Gloves" />
                            <ListItem text="Safety footwear" />
                            <ListItem text="Eye and Hearing protection" />
                            <ListItem text="Overalls" />
                            <ListItem text="(You may require sunscreen)" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        pla_bur_hot_lan: {
            name: "Burner/ Hot Air Lance/ PPE Training",
            icon: pla_bur_hot_air_lan,
            text: (
                <ul>
                    <ListItem text="Ensure that operatives are properly trained to operate this equipment" />
                    <ListItem text="These devices operate at very high temperatures, so must be sued with extreme care. Plan how you are going to complete the entire task and then plan your safe methodology." />
                    <ListItem text="Do NOT leave the Lance unattended." />
                    <ListItem text="After use, continue to directly supervise the lance, Do NOT place near flammable material until it has cooled down." />
                    <ListItem text="Ensure a high level of equipment maintenance and perform a visual check on condition, pipes and fixings prior to each use." />
                    <ListItem text="Use gloves, full face protection, overalls, safety footwear and hearing protection." />
                </ul>
            )
        },
        pla_atv_tra_ppe: {
            name: "ATV/ Training/ PPE",
            icon: pla_atv_tra_ppe,
            text: (
                <ul>
                    <ListItem text="ATV must be registered, have current road tax, and be insured for on-road use" />
                    <Li>
                        <Typography variant="title">
                            Driver must have appropriate licence
                        </Typography>
                        <ol>
                            <ListItem text="Light Quad (<425 Kg) = AM Category" />
                            <ListItem text="Heavy Quad (> 425 Kg) = B Category" />
                        </ol>
                    </Li>
                    <ListItem text="Driver must wear motorcycle class safety helmet" />
                    <ListItem text="If driving off-road, drive to ensure no risk of overturning" />
                    <ListItem text="If controlling traffic, ensure sign is securely fitted and 360o warning beacons in operation" />
                </ul>
            )
        },
        pla_gas_cyl_bio: {
            name: "Gas Cylinder/ Boiler Servicing/ Training",
            icon: pla_gas_cyl_tra,
            text: (
                <ul>
                    <ListItem text="You must be properly trained to operate this equipment." />
                    <ListItem text="The equipment must be properly and regularly serviced" />
                    <ListItem text="You must have the correct fire extinguishing equipment close by (not within the immediate fire danger area)." />
                    <ListItem text="Only tackle fire if in early stages, and turn off source first if possible. If safe move gas cylinder away from fire area." />
                    <ListItem text="Cylinders must be upright during handling, transport, storage and use" />
                    <ListItem text="If they have been laid down, they must be placed upright for a minimum of 30 minutes before use" />
                    <ListItem text="Protect cylinders from sunlight" />
                    <ListItem text="Cannot be toppled, dropped or rolled on their side" />
                    <ListItem text="Do NOT use valves as lifting points" />
                    <ListItem text="If leak is detected, stop leak if possible without personal risk. Keep people away. Isolate and remove sources of ignition. Ensure ventilation." />
                    <ListItem text="Do not exceed the maximum temperature of the Boiler" />
                    <ListItem text="Avoid contamination of the boiler contents with water" />
                    <ListItem text="Ensure adequate ventilation" />
                    <ListItem text="Store uncooked material in a cool dry place." />
                    <ListItem text="Follow procedure to secure equipment for transport." />
                </ul>
            )
        },
        pla_com_pla_sec: {
            name: "Compound/ Plant Security",
            icon: pla_com_pla_sec,
            text: (
                <ul>
                    <ListItem text="A designated, secure (fenced off) area should be used for storing plant and materials when not in use, or when the site is left unattended." />
                    <ListItem text="The area must be secured from unauthorised access, or at remote sites, arrangements put in place to prevent unauthorised access." />
                </ul>
            )
        },

        pla_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: pla_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};
export default json;
